import deleteImage from './delete.svg';
import warningImage from './warning.webp';

const ACTION_IMAGES = { deleteImage, warningImage };

export default ACTION_IMAGES;
